import { render, staticRenderFns } from "./CourseStatsDetail.vue?vue&type=template&id=2014b59c&scoped=true&"
import script from "./CourseStatsDetail.vue?vue&type=script&lang=js&"
export * from "./CourseStatsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014b59c",
  null
  
)

export default component.exports